import { createSlice } from '@reduxjs/toolkit';
import { ExecutedCommand } from '../../Modules/Nczi/Commands/Command';

export interface NcziState {
	commands: ExecutedCommand[];
}

const initialState: NcziState = {
	commands: [],
};

export const ncziSlice = createSlice({
	name: 'nczi',
	initialState,
	reducers: {
		setNcziCommands: (state, { payload }) => {
			state.commands = payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setNcziCommands } = ncziSlice.actions;
export const selectNcziComands = (state: any) => state.nczi.commands;

export default ncziSlice.reducer;
